import { VoltageUnit } from '@/entities/voltage-unit';

export function dynamicVoltageUnit(v: number): VoltageUnit {
  if (v === 0) return VoltageUnit.V;

  const unit = Math.floor(Math.log10(Math.abs(v)) / 3);

  if (unit <= 0) return VoltageUnit.V;
  if (unit === 1) return VoltageUnit.KV;
  return VoltageUnit.MV;
}
